import React from 'react';

import './index.scss';
import voicemailIcon from '@/public/icons/side-bar/voicemail.svg';
import { IVoicemail } from '@/shared/interfaces/voicemail.interface';

type Props = {
  setItemChosen: (value: IVoicemail) => void;
  list: IVoicemail[];
};

export const VoicemailList = ({ setItemChosen, list }: Props) => {
  const handleClick = (item: IVoicemail) => {
    return () => setItemChosen(item);
  };

  return (
    <>
      {list.map((item) => (
        <div
          key={item.id.toString()}
          className="list-item"
          onClick={handleClick(item)}
        >
          <div className="heading">
            <img src={voicemailIcon} alt="icon" />
            <span className="name">Voicemail Name {item.caller}</span>
          </div>
          <div className="timing">1 min</div>
        </div>
      ))}
    </>
  );
};
